import type { AccommodationTileType } from '@/features/accommodation-tiles/accommodation-type';

import React from 'react';

import { useDeviceoutput } from '@/core/features/cookies/use-device-output';

type AccommodationTileRatingProps = Pick<AccommodationTileType, 'rating'> & {
    size: 24 | 28 | 32 | 34;
};

export default function AccommodationTileRating({ rating, size }: AccommodationTileRatingProps) {
    const { isDesktopView } = useDeviceoutput();
    const noRating = !rating.countText;

    return (
        <div className={'flex gap-7'}>
            <span
                className={`${isDesktopView ? 'font-size-16' : 'font-size-12'} flex-center bold text-white bg-check24Blue`}
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ borderRadius: '5px 5px 0 5px', height: size, width: size }}
            >
                {rating.scoreText}
            </span>
            <div
                className={`${isDesktopView ? 'flex-start-vertical gap-3' : 'flex-space-between-vertical'} font-size-12`}
            >
                <div className={`height-12 line-height-12 ${noRating ? '' : 'bold'}`}>{rating.scoreDescription}</div>
                {rating.countText && <div className={'text-dove-gray'}>{rating.countText}</div>}
            </div>
        </div>
    );
}
